import { useCasinosQuery } from 'hooks/api/casino';
import { useCurrentRegion } from './useCurrentRegion';

type Props = {
  skip?: boolean;
  collection?: string;
  skipRegionFilter?: boolean;
};

export const useCasinos = (props?: Props) => {
  const { collection, skip, skipRegionFilter } = props ?? {};

  const { isFetching: isCountriesFetching, currentRegion } = useCurrentRegion();

  const { data: { results: casinos = [], count = 0 } = {}, isFetching } =
    useCasinosQuery(
      {
        collections: collection,
        countries: skipRegionFilter ? undefined : currentRegion?._id,
      },
      { skip: (!skipRegionFilter && isCountriesFetching) || skip }
    );

  return {
    count,
    casinos,
    isFetching: isFetching || (!skipRegionFilter && isCountriesFetching),
  };
};
